"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var processModifiers_1 = __importStar(require("./utils/processModifiers"));
var composeClassNames_1 = __importStar(require("./utils/composeClassNames"));
var constants_1 = require("./constants");
var className = function (baseClass, modifiersCallback) { return function (parameters) {
    if (parameters === void 0) { parameters = {}; }
    var requiredParameters = {
        props: parameters.props || {},
        state: parameters.state || {},
    };
    return {
        baseClass: baseClass,
        block: function () {
            var modifiers = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                modifiers[_i] = arguments[_i];
            }
            if (typeof modifiersCallback === 'function') {
                modifiers = processModifiers_1.unique(processModifiers_1.default(modifiersCallback, requiredParameters), processModifiers_1.filter(modifiers));
            }
            return composeClassNames_1.default(baseClass, modifiers);
        },
        compose: function () {
            var classNames = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                classNames[_i] = arguments[_i];
            }
            return composeClassNames_1.join(classNames);
        },
        create: function (newClass, block, excludeModifiers) {
            if (block === void 0) { block = true; }
            if (excludeModifiers === void 0) { excludeModifiers = false; }
            if (block) {
                newClass = "" + baseClass + constants_1.BLOCK_DELIMITER + newClass;
            }
            return className(newClass, excludeModifiers ? undefined : modifiersCallback)(requiredParameters);
        },
        element: function (className) {
            var modifiers = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                modifiers[_i - 1] = arguments[_i];
            }
            return composeClassNames_1.default("" + baseClass + constants_1.ELEMENT_DELIMITER + className, modifiers);
        },
        extra: function (className, prefix) {
            if (prefix === void 0) { prefix = ''; }
            if (prefix) {
                return "" + prefix + constants_1.BLOCK_DELIMITER + className;
            }
            return className;
        },
    };
}; };
exports.default = className;
//# sourceMappingURL=className.js.map